import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Grid,
  Button,
  OutlinedInput,
  InputLabel,
  FormControl,
  Typography,
  Tooltip,
  AppBar,
  Toolbar,
  IconButton,
} from '@mui/material';
import { ArrowBackIos, ArrowUpward } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { api } from '../../api/instance';
import Time from '../../utils/TimeFormats';
import ProjectImageUpload from '../Projects/ProjectImageUpload';
import deleteUpload from '../../utils/deleteUpload';
import Loader from '../../components/Loader/Loader';

const SliderEdit = () => {
  const [searchParams] = useSearchParams();
  const itemId = searchParams.get('id');
  const [slider, setSlider] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  // const { setUpdateProjects } = useProjects();
  const formRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const mode = location.state.mode;

  useEffect(() => {
    const getSliderDetails = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/sliders/${itemId}`);
        console.log('SLIDES', response.data.slider);
        setSlider(response.data.slider);
        setLoading(false);
      } catch (error) {
        setSlider({});
        setLoading(false);
        console.log(error);
      }
    };

    if (mode === 'edit') {
      getSliderDetails();
    }
  }, [itemId]);

  // move this function to a hook
  const formSubmit = async () => {
    setSubmitting(true);
    // slider comes from the state
    if (mode === 'edit') {
      console.log('UPDATE DATA:', slider);
      const response = await api.put(`/sliders/${itemId}`, slider);

      if (response.status === 200) {
        setSubmitting(false);
        // maybe I could show a message instead of redirection
        // setUpdateProjects(true);
        navigate('/sliders');
      } else {
        console.log('Could not update', slider);
        setTimeout(() => {
          setSubmitting(false);
        }, 1000);
      }
    }

    if (mode === 'create') {
      const response = await api.post('/sliders', slider);

      if (response.status === 201) {
        setSubmitting(false);
        // maybe I could show a message instead of redirection
        // setUpdateProjects(true);
        navigate('/sliders');
      } else {
        console.log('Could not create', slider);
        setTimeout(() => {
          setSubmitting(false);
        }, 1000);
      }
    }
  }; // CREATE/EDIT FORM SUBMIT


  const deleteProject = async () => {
    // console.log('ID', itemId);
    // // delete uploads if any
    // if (project.images.length >= 1) {
    //   console.log('Deleted images');
    //   project.images.forEach(async (value, key) => {
    //     await deleteUpload(value.path);
    //     setProject({ ...project, images: [] });
    //   });
    // }
    // // delete project if on edit more and images are deleted
    // if (mode === 'edit') {
    //   try {
    //     const response = await api.delete(`/projects/${itemId}`);
    //     if (response.status === 200) {
    //       console.log('project deleted');
    //       setProject({});
    //       setUpdateProjects(true);
    //       navigate('/sliders');
    //     }
    //   } catch (error) {
    //     console.log('Could not delete project');
    //   }
    // }
    // // return to projects when on create mode
    // if (mode === 'create') {
    //   console.log('Cancelled creation process');
    //   setProject({});
    //   // setUpdateProjects(true);
    //   navigate('/sliders');
    // }
  }; // DELETE PROJECT

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Grid item xs={8} sx={{ marginBottom: '0.5rem' }}>
        <Link to="/sliders">
          <Button color="primary">
            <ArrowBackIos /> SLIDERS
          </Button>
        </Link>
      </Grid>

      {loading ? (
        <Loader />
      ) : (
        <Grid item xs={12} sm={12} md={8}>
          <Typography variant="h4" className="lato" margin="normal">
            {slider.name}
          </Typography>
          <Typography variant="caption">
            {mode === 'edit' ? 'LAST UPDATE' : 'CREATED BY'} {slider.createdBy ? slider.createdBy.name : ''}{' '}
            {slider.createdBy ? slider.createdBy.surname : ''} {Time.dateFullFormat(slider.lastUpdated)}
          </Typography>

          <form data-abide noValidate id="createForm" className="cell" onSubmit={(e) => formSubmit(e)} encType="multipart/form-data" ref={formRef}>
            <input type="text" className="is-hidden" name="createdBy" id="createdBy" aria-errormessage="dateCreatedErr" value="USERNAME" readOnly />

            <FormControl fullWidth margin="normal">
              <InputLabel htmlFor="name">Slider Name</InputLabel>
              <OutlinedInput
                id="name"
                name="name"
                label="Slider Name"
                onChange={(e) => setSlider({ ...slider, name: e.target.value })}
                value={slider.name}
              />
            </FormControl>
          </form>

          <ProjectImageUpload type="slider" apiPath="/sliders/upload" images={slider && slider.images} setter={setSlider} />

          <AppBar
            position="relative"
            className="sticky"
            data-margin-bottom="0"
            data-sticky
            data-stick-to="bottom"
            color="default"
            style={{ top: 'auto', bottom: 0, borderRadius: '0.2rem', background: '#fff' }}
          >
            <Toolbar>
              <div style={{ flex: 2 }}>
                <Tooltip title="Top" placement="top">
                  <IconButton fontSize="small" onClick={scrollTop} style={{ marginLeft: -12, marginRight: 20 }} color="primary" aria-label="Menu">
                    <ArrowUpward />
                  </IconButton>
                </Tooltip>
              </div>
              <div className="right" style={{ gap: '1rem', display: 'flex' }}>
                <Button fontSize="small" onClick={() => deleteProject()} style={{ flex: 1 }} color="error" aria-label="Menu">
                  {mode === 'edit' ? 'DELETE' : 'CANCEL'}
                </Button>
                <Button fontSize="small" onClick={() => formSubmit()} style={{ flex: 1 }} color="primary" aria-label="Menu">
                  {submitting ? 'Saving' : 'Save'}
                </Button>
              </div>
            </Toolbar>
          </AppBar>
        </Grid>
      )}
    </>
  );
};

export default SliderEdit;
